<template>
    <div id="login">
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Loading...</p>
            </div>
        </transition>
        <section>
            <div class="login-wrap">
                <form v-if="showLoginForm" @submit.prevent>
                    <h1>Innskráning</h1>
                    <div class="login-title">
                        <label for="email1">Email</label>
                    </div>
                    <div class="login-input">
                        <input v-model.trim="loginForm.email" type="text" placeholder="you@email.com" id="email1" />
                    </div>

                    <div class="login-title">
                        <label for="password1">Password</label>
                    </div>
                    
                    <div class="login-input">
                        <input v-model.trim="loginForm.password" type="password" placeholder="******" id="password1" />
                    </div>
                    <div class="login-button">
                        <button @click="login" class="button">Skrá inn</button>
                    </div>

                </form>
                <transition name="fade">
                    <div v-if="errorMsg !== ''" class="error-msg">
                        <p>Incorrect username or password.</p>
                    </div>
                </transition>
            </div>
        </section>
    </div>
</template>

<script>
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
                loginForm: {
                    email: '',
                    password: ''
                },
                showLoginForm: true,
                performingRequest: false,
                errorMsg: ''
            }
        },
        methods: {
            login() {
                this.performingRequest = true
                fb.auth.signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password).then(user => {
                    user
                    this.performingRequest = false
                    this.$router.push('/admin-panel')
                }).catch(err => {
                    this.performingRequest = false
                    this.errorMsg = err.message
                })
            }
        }
    }
</script>

<style>
.login-wrap {
    margin: auto;
    margin-top: 2rem;
    width:800px;
    height:400px;
    background-color: white;
}
.login-wrap h1 {
    margin: 0;
    padding-top: 20px;
    font-size: 26px;
    margin-bottom: 20px;
}
.login-title {
    margin: auto;
    margin-top: 10px;
}
.login-title label {

}
.login-input {
    margin: auto;
    margin-top: 5px;
}
.login-input input {
    text-align: center;
    padding:5px;
    width: 300px;
    height:40px;
    border-radius: 30px;
    background-color: #f0f0f0;
    font-size: 16px;
    border:none;
}
.login-button {
    margin-top: 20px;
}
.login-button button {
    margin-top: 20px;
    width: 300px;
    height: 50px;
    background-color: #b33b3b;
    border: none;
    border-radius: 30px;
    color: white;
    font-size: 20px;
}
</style>